<template>
    <Paper class="install finance-detail">
        <div class="contents" v-loading="manualLoading">
            <div class="buttons">
                <el-button @click="goLists">返 回</el-button>
                <el-button type="primary" :disabled="isConfirm" @click="confirm" v-has="'07010002'">提交确认</el-button>
                <el-button type="primary" :disabled="isRecall" @click="withdraw" v-has="'07010008'" :loading="recallLoading">撤 回</el-button>
            </div>
            <div class="base-line"></div>
            <div class="head-content">
                <div class="head-title">
                    <div class="head-t">
                        <h3 class="head-h3">任务编号：{{this.$route.query.feeTaskCode}}</h3>
                        <span class="head-r">{{status}}</span>
                    </div>
                    <el-button class="head-btn" @click="isShow = !isShow">{{this.isShow ? '收起' : '展开'}}</el-button>
                </div>
                <el-collapse-transition>
                    <div v-show="isShow" class="head">
                        <ElRow :infoData="infoData"></ElRow>
                    </div>
                </el-collapse-transition>
            </div>
            <div class="details-title">
                <div class="left">
                    <span class="bill-details">网点安装任务明细</span>
                    <el-button v-has="'07010003'" :disabled="isConfirm" class="upload" type="primary" @click="saveDetails">保 存</el-button>
                    <el-button v-has="'07010004'" :disabled="isConfirm" class="upload" type="primary" @click="saveAllDetails">批量确认费用</el-button>
                    <el-upload class="upload" :disabled="isConfirm" action :show-file-list="false" :before-upload="beforeUpload" :on-success="afterUpload" :http-request="submitUpload">
                        <el-button v-has="'07010005'" :disabled="isConfirm" type="primary">核对费用导入</el-button>
                    </el-upload>
                </div>
                <div class="right">
                    <el-button v-has="'07010006'" type="text" icon="el-icon-download" @click="exportTaskDetail('install')">导出安装任务明细</el-button>
                    <el-button v-has="'07010007'" type="text" icon="el-icon-download" @click="exportFeeDetail('installCost')">导出安装费用明细</el-button>
                </div>
            </div>
            <template class="table-head">
                <el-table style="width: 100%" @current-change="handleCurrentChange" highlight-current-row v-loading="loading" :data="tableDataLists" border height="200" ref="dragTable">
                    <el-table-column align="center" show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in tableDataItems" :key="index">
                        <template slot-scope="scope">
                            <span class="center">
                                <el-input :class="{red: scope.row.hasValue}" clearable @input="proving(scope.$index)"
                                @change="inputChange(scope.row)" v-if="item.prop==='supplierAmount'&&scope.row.editing === 'arrive'"
                                v-model="scope.row[item.prop]"></el-input>
                                <el-input clearable maxlength="50" v-else-if="item.prop==='supplierMsg'&&scope.row.editing === 'arrive'" v-model.trim="scope.row[item.prop]" ></el-input>
                                <span v-else>{{scope.row[item.prop]}}</span>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination small layout="prev, pager, next" @current-change="pageChange" :total="tableDataListsLenth"></el-pagination>
                </div>
            </template>
            <span class="bill-details">网点安装费用明细</span>
            <template class="table-head">
                <el-table v-loading="loading2" :data="tableDataLists2" border height="250" ref="dragTable" >
                    <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" :width="item.width" v-for="(item, index) in costTableDataItems" :key="index" ></el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination small layout="prev, pager, next" @current-change="pageChange2" :total="tableDataLists2Lenth"></el-pagination>
                </div>
            </template>
        </div>
    </Paper>
</template>

<script>
import Paper from '@/components/core/paper/Paper';
import { getCostDetails, getFeeDetails, saveDetails, confirm, getUploadLists, getTasks } from '../../../api/cost.js';
import index from './config.js';
import ElRow from './components/ElRow';
import { COST_BMS_TASK_STATUS, CUSTOM } from '../../../utils/configuration';
import common from '../../../common/common';
import { myXixins } from '../../../mixins/mixins';
import InstallClass from '../../../common/InstallClass';
import { mapGetters } from 'vuex';
const { initSessionData } = common;
const INSTALL_CODE = '15';
const TOTAL_TEN = '10'; // 任务数量
export default {
    name: 'installDetail',
    components: { Paper, ElRow },
    mixins: [myXixins],
    data() {
        return {
            index,
            manualLoading: true,
            isShow: true,
            isConfirm: true,
            isRecall: true,
            loading: false,
            loading2: false,
            recallLoading: false,
            infoData: {},
            fineObj: {},
            searchObj: { pageNo: 1, pageSize: 10 },
            searchObjList: { pageNo: 1, pageSize: 10 },
            arr: [],
            arrList: [],
            tableArray: [],
            tableDataLists: [{ editing: 'arrive' }],
            tableDataLists2: [],
            tableDataItems: [],
            jobId: 1,
            pageNo: 1,
            totalTasks: 0,
            currentPage: 1,
            pageSize: 10,
            tableDataLists2Lenth: 0,
            tableDataListsLenth: 0,
            status: '',
            tasktype: '',
            costNumber: '',
            businessTypeData: ''
        };
    },
    methods: {
        inputChange(row) {
            if (row.supplierAmount) {
                row.hasValue = false;
            }
        },
        getData() {
            this.manualLoading = true;
            if (this.$route.query.hasOwnProperty('feeTaskCode') && this.$route.query.feeTaskCode !== null && this.$route.query.feeTaskCode !== '') {
                const params = { pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize, feeTaskCode: this.$route.query.feeTaskCode };
                getTasks(params).then(res => {
                    if (res && res.code === '0') {
                        this.fineObj = res.data.list[0];
                        this.infoData = new InstallClass(this.fineObj);
                        const { BID_BUSINESS_TYPE, SRM_BMS_TASK_TYPE, SYS_BMS_TASK_STATUS } = window.sessionStorage;
                        this.infoData.businessType = BID_BUSINESS_TYPE ? JSON.parse(BID_BUSINESS_TYPE)[this.infoData.businessType] : this.infoData.businessType;
                        this.infoData.feeTaskType = SRM_BMS_TASK_TYPE ? JSON.parse(SRM_BMS_TASK_TYPE)[this.infoData.feeTaskType] : this.infoData.feeTaskType;
                        this.status = SYS_BMS_TASK_STATUS ? JSON.parse(SYS_BMS_TASK_STATUS)[this.fineObj.status] : this.fineObj.status;
                        this.isConfirm = this.fineObj.status !== COST_BMS_TASK_STATUS.TO_BECON_FIRMED;
                        if (this.fineObj.status === COST_BMS_TASK_STATUS.COST_CONSISTENT || this.fineObj.status === COST_BMS_TASK_STATUS.COST_DIFFERENCE) {
                            this.isRecall = false;
                        } else {
                            this.isRecall = true;
                        }
                    }
                    this.manualLoading = false;
                    this.load();
                }).catch(() => {});
            } else {
                this.manualLoading = false;
                this.fineObj = {};
                this.routeJump();
            }
        },
        load() {
            if (this.$route.query.hasOwnProperty('feeTaskCode') && this.$route.query.feeTaskCode !== null) {
                var temp = { feeTaskCode: this.$route.query.feeTaskCode, pageNo: this.searchObj.pageNo, pageSize: this.searchObj.pageSize };
                this.currentPage = this.searchObj.pageNo;
                this.loading = true;
                getCostDetails(temp).then(res => {
                    if (res && res.code === '0') {
                        this.loading = false;
                        this.arr = res.data.list.map(item => item.supplierAmount);
                        this.tableDataLists = res.data.list.map(item => {
                            item.hasValue = false;
                            item.editing = 'arrive';
                            item.editing = this.fineObj.status === COST_BMS_TASK_STATUS.TO_BECON_FIRMED ? 'arrive' : '';
                            return item;
                        });
                        this.tableDataListsLenth = res.data.totalCount;
                        this.totalTasks = res.data.totalPage;
                    }
                });
            } else {
                this.loading = false;
                this.arr = [];
                this.routeJump();
            }
        },
        saveDetails() {
            var datas = [];
            for (var i = 0; i < this.tableDataLists.length; i++) {
                if (this.tableDataLists[i].supplierAmount === '' || this.tableDataLists[i].supplierAmount === undefined) {
                    return this.$message.warning('确认费用金额不能为空');
                }
                if (Number(this.tableDataLists[i].supplierAmount) !== this.tableDataLists[i].amount &&
                (this.tableDataLists[i].supplierMsg === undefined || this.tableDataLists[i].supplierMsg === '')) {
                    this.$message.warning('确认金额不一致，请备注原因');
                    return;
                } else {
                    var data = {
                        feeTaskCode: this.$route.query.feeTaskCode,
                        jobId: this.tableDataLists[i].jobId,
                        supplierAmount: this.tableDataLists[i].supplierAmount,
                        supplierMsg: this.tableDataLists[i].supplierMsg
                    };
                    datas.push(data);
                }
            }
            saveDetails(datas).then(res => {
                if (res && res.code === '0') {
                    this.fineObj.status = res.data.status;
                    this.fineObj.supplierComfirmAmount = res.data.supplierComfirmAmount;
                    this.arrList = this.tableDataLists.map(item => item.supplierAmount);
                    this.arr = this.arrList;
                    this.$message.success('保存成功');
                }
                this.getData();
            });
        },
        saveAllDetails() {
            if (this.totalTasks > TOTAL_TEN) {
                return this.$message.warning('此按钮只适用10条内的明细数据');
            } else {
                this.batchConfirmation();
            }
        },
        batchConfirmation() {
            var datas = [];
            for (var i = 0; i < this.tableDataLists.length; i++) {
                var data = {
                    feeTaskCode: this.$route.query.feeTaskCode,
                    jobId: this.tableDataLists[i].jobId,
                    supplierAmount: this.tableDataLists[i].supplierAmount || this.tableDataLists[i].amount,
                    supplierMsg: this.tableDataLists[i].supplierMsg
                };
                datas.push(data);
            }
            saveDetails(datas).then(res => {
                if (res && res.code === '0') {
                    this.fineObj.status = res.data.status;
                    this.fineObj.supplierComfirmAmount = res.data.supplierComfirmAmount;
                    for (var i = 0; i < this.tableDataLists.length; i++) {
                        if (this.fineObj.status && this.fineObj.status === COST_BMS_TASK_STATUS.TO_BECON_FIRMED) {
                            this.$set(this.tableDataLists[i], 'editing', 'arrive');
                            this.tableDataLists[i].hasValue = true;
                        }
                    }
                    this.arrList = this.tableDataLists.map(item => item.supplierAmount);
                    this.arr = this.arrList;
                    this.$message.success('批量确认成功');
                }
                this.getData();
            });
        },
        confirm() {
            var data = { id: this.$route.query.jobid, feeTaskCode: this.$route.query.feeTaskCode };
            this.tableArray = this.tableDataLists.every(item => {
                return item.supplierAmount !== undefined && item.supplierAmount !== '';
            });

            if (!this.tableArray) {
                return this.$message.warning('确认费用金额不能为空');
            } else {
                for (let i = 0; i < this.tableDataLists.length; i++) {
                    if (Number(this.tableDataLists[i].supplierAmount) !== this.tableDataLists[i].amount &&
                (this.tableDataLists[i].supplierMsg === undefined || this.tableDataLists[i].supplierMsg === '')) {
                        return this.$message.warning('确认金额不一致，请备注原因');
                    }
                }
            }
            if (this.tableDataLists.map(item => item.supplierAmount).toString() === this.arr.toString()) {
                confirm(data).then(res => {
                    if (res && res.code === '0') {
                        this.fineObj.status = res.data.status;
                        this.fineObj.supplierComfirmAmount = res.data.supplierComfirmAmount;
                        for (let index = 0; index < this.tableDataLists.length; index++) {
                            this.tableDataLists[index].editing = '';
                        }
                    }
                    this.getData();
                });
            } else {
                return this.$message.warning('数据已更改，请先保存之后再提交');
            }
        },
        handleCurrentChange(val) {
            if (val) this.jobId = val.jobId;
            if (val) this.getFeeDetails();
        },
        getFeeDetails() {
            if (this.jobId === 1) { return; }
            // if (this.fineObj.feeTaskType === '20') {
            //     this.businessTypeData = '100';
            // } else {
            //     this.businessTypeData = this.fineObj.businessType;
            // }
            this.businessTypeData = INSTALL_CODE;
            var temp = { jobId: this.jobId, businessType: this.businessTypeData, ...this.searchObjList };
            this.currentPage = this.searchObj.pageNo;
            this.loading2 = true;
            getFeeDetails(temp).then(res => {
                if (res && res.code === '0') {
                    this.loading2 = false;
                    this.tableDataLists2 = this.formatData(res.data.list);
                    this.tableDataLists2Lenth = res.data.totalCount;
                }
            });
        },
        formatData(data) {
            data.map(item => {
                item.isEngineer = item.isEngineer > 0 ? '是' : '否';
            });
            return data;
        },
        submitUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('file', file);
            formData.append('feeTaskCode', this.$route.query.feeTaskCode);
            formData.append('businessType', this.fineObj.businessType);
            formData.append('pageNo', 1);
            formData.append('pageSize', CUSTOM.NINE_HUNDRED_AND_NINETY_NINE);
            getUploadLists(formData).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('导入成功');
                    this.load();
                }
            })
                .catch(() => {});
        }
    },
    mounted() {
        initSessionData(['SYS_BMS_TASK_STATUS', 'SRM_BMS_TASK_TYPE', 'BID_BUSINESS_TYPE']);
        this.getData();
    },
    computed: {
        ...mapGetters(['visitedViews'])
    },
    activated() {
        this.getData();
    },
    created() {
        this.infoData = index.infoData;
        this.tableDataItems = index.tableDataItems;
        this.costTableDataItems = index.costTableDataItems;
    }
};
</script>

<style lang="less">
@import "../../../styles/common.less";
@import "./install.less";
</style>
